<template>
    <button
      class="py-2 px-4 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] cursor-pointer rounded-lg transition-colors hover:scale-101 active:scale-99 duration-300 flex items-center gap-2 w-full text-nowrap"
      :class="[
        textColor,
        bgColor,
        borderColor,
        hoverBgColor,
        { 'bg-opacity-80': active }
      ]"
      :label="label"
      :severity="severity"
    >
    <slot class="w-full">
      {{ title }}
    </slot>
    <component v-if="icon" :is="icon" class="icon" :class="customIcon" />
    </button>
  </template>

  <script setup>


  defineProps({
    icon: Object,
    active: Boolean,
    label: {
      type: String,
      default: "Primary"
    },
    severity: {
      type: String,
      default: "primary"
    },
    textColor: {
      type: String,
      default: "text-[#385660]" // Color de texto por defecto
    },
    bgColor: {
      type: String,
      default: "bg-white" // Fondo por defecto
    },
    borderColor: {
      type: String,
      default: "border border-[#c1c1c1]" // Borde por defecto
    },
    hoverBgColor: {
      type: String,
      default: "hover:bg-[#eafaff]" // Hover por defecto
    },
    title:String,
  });
  </script>
